import { render, staticRenderFns } from "./index.html?vue&type=template&id=2c0e789a&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.sass?vue&type=style&index=0&id=2c0e789a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0e789a",
  null
  
)

component.options.__file = "index.vue"
export default component.exports